import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js'
import {html} from '@polymer/polymer/lib/utils/html-tag.js';

/**
 * `cbar-list-item-group`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarListItemGroup extends PolymerElement {
  static get template() {
    return html`
        <style include="cbar-shared-styles">
            :host {
                display: block;
                position: relative;
            }

            [hidden] {
                display: none;
            }

            a {
                text-decoration: none;
                color: inherit;
                background: inherit;
                outline: none;
                pointer-events: auto;
            }

            #trigger {
                display: flex;
                align-items: center;
            }

            #trigger iron-icon {
                /**
                 * Position the chevron absolutely and disable click events
                 * to ensure the slotted trigger gets all the focus on tap
                 */
                position: absolute;
                right: 10px;

                pointer-events: none;
            }

            #trigger ::slotted([slot=dropdown-trigger]) {
                /** Make the slotted trigger item take up 100% of the space **/
                flex-grow: 1;
            }

            iron-collapse {
                outline: none;
            }

            iron-collapse ::slotted(*) {
                padding-left: 30px;
            }

            .chevron {
                transition: transform 0.3s;
            }

            paper-listbox {
                padding: 0;
                color: inherit;
                background: inherit;
            }

            .chevron-opened {
                transform: rotateZ(90deg);
            }
        </style>

        <paper-listbox>
            <div id="trigger" on-tap="toggleDropdown">
                <slot name="dropdown-trigger"></slot>
                <iron-icon icon="chevron-right" class\$="chevron [[_chevronClass]]"></iron-icon>
            </div>

            <iron-collapse opened="{{opened}}">
                <slot></slot>
            </iron-collapse>
        </paper-listbox>
    `;
  }

  static get is() {
    return 'cbar-list-item-group';
  }

  static get properties() {
    return {
      opened: {
        type: Boolean,
        value: false,
        notify: true,
        observer: "__handleOpened"
      },
    };
  }

  __handleOpened(opened) {
    this._chevronClass = opened ? 'chevron-opened' : '';
  }

  toggleDropdown() {
    this.opened = !this.opened;

    if (document.activeElement && document.activeElement.blur) {
      // Sometimes when collapsing, a child element (usually a paper-item)
      // gets stuck focused.
      document.activeElement.blur();
    }
  }
}

window.customElements.define(CbarListItemGroup.is, CbarListItemGroup);
